import React from "react"


export const Card = ({ children }: { children: React.ReactNode }) => {
    const childrenArray = React.Children.toArray(children);
    return (
        <div className='flex flex-col gap-11 justify-center items-center md:pt-0 pt-8 bg-[#f1f1f1] md:absolute md:left-[50%] md:top-[50%] md:translate-y-[-50%] md:translate-x-[-50%] px-5 md:px-0'>
            <div className='bg-white rounded-xl shadow-[0_4px_15px_0px_rgba(0,0,0,0.1)] md:w-[512px] w-full md:p-10 p-5'>
                {childrenArray.filter(child => !React.isValidElement(child) || child.type !== Card.Tail)}
            </div>
            {childrenArray.find(child => React.isValidElement(child) && child.type === Card.Tail)}
        </div>
    )
};

Card.Header = ({title, subtitle}: {title: string, subtitle?: string}) => {
    return (
        <div className='flex flex-col gap-2'>
            <h2 className="text-2xl text-[#365053] font-bold pb-4">{title}</h2>
            {subtitle && (
                <h3 className='text-sm block text-[#A0A0A0] font-bold pb-2 uppercase'>{subtitle}</h3>
            )}
        </div>
    );
}


Card.Tail = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className='mx-auto text-center max-w-lg px-5'>
            {children}
        </div>
    );
};
